import React from "react";
import { Button } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useServiceMode } from "../../../hooks/useReduxSelectors";

const MoreCommandButton = React.memo(({ hwId, independent, isExpanded, onToggle, disabled }) => {
  const serviceMode = useServiceMode();

  if ((serviceMode?.isActive && serviceMode.status === "ManualActive") || independent) {
    return (
      <Button
        color={isExpanded ? "secondary" : "dark"}
        onClick={onToggle}
        disabled={disabled}
      >
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", alignItems: "center" }}>
          <i className="icon-custom-command" />
          <span style={{ fontSize: "12px", fontWeight: 600 }}>C</span>
          {isExpanded ?
            <ExpandLessIcon sx={{ fontSize: 20 }} />
            :
            <ExpandMoreIcon sx={{ fontSize: 20 }} />
          }
        </div>
      </Button>
    );
  } else {
    return <></>;
  }
});

export default MoreCommandButton;
